// removed by extract-text-webpack-plugin
module.exports = {"ordersList":"_3EAF1","empty":"_3_hW_"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/OrdersList/index.sass
// module id = 1493
// module chunks = 1